import { PATH } from '#const/path';
import { useNavigate } from 'react-router';
import * as S from './styles';
import { Button, Flex, Input } from '#atoms';
import { FloatButtonContainer, Modal } from '#molecules';
import { useState } from 'react';
import { useToast } from '#providers/ToastProvider';
import usePartnerCodeMutation from '#hooks/queries/accounts/usePartnerCodeMutation';

export function FibudPartners() {
  const navigate = useNavigate();
  const handleClickXIcon = () => {
    navigate(PATH.HOME, { replace: true });
  };
  const [isOpen, setIsOpen] = useState(false);
  const [code, setCode] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const { showToast } = useToast();
  const { mutateAsync: submitPartersCode, isLoading } =
    usePartnerCodeMutation();

  const close = () => {
    setIsOpen(false);
    setCode('');
  };

  const handleSubmitCode = async () => {
    try {
      await submitPartersCode(code);
      close();
      showToast({
        message: '피벗 프로 무료 혜택이 정상적으로 적용되었습니다!',
        type: 'success'
      });
      navigate(PATH.HOME, { replace: true });
    } catch (err: any) {
      setErrorMessage(
        '입력하신 제휴코드가 일치하지 않습니다. 다시 입력해 주세요.'
      );
    }
  };

  return (
    <>
      <S.Header align="center" justify="flex-end">
        <span style={{ paddingTop: '4px' }} onClick={handleClickXIcon}>
          <XIcon />
        </span>
      </S.Header>
      <S.Wrapper>
        <Flex gap={8} align="center">
          {/* <S.Title>피벗 파트너스</S.Title> */}
          <S.Title>피벗 프로</S.Title>
          <S.Badge>PRO</S.Badge>
        </Flex>
        <Flex direction="column" gap={30}>
          <S.Wrapper2>
            {/* 피벗과 제휴된 협력 교육 기관의 수료생이신가요?{'\n'}
            제공된 코드를 입력하여 혜택을 받아보세요! */}
          </S.Wrapper2>
          <S.Benefis direction="column" gap={8}>
            {benefits.map(benefit => (
              <Flex gap={8} align="center">
                <TickIcon /> <S.Benefit>{benefit}</S.Benefit>
              </Flex>
            ))}
          </S.Benefis>
          <S.Divider></S.Divider>
          <S.Title2>
            <S.Strong>잠깐! </S.Strong>피벗과 제휴된
            <br />
            기관/기업의 트레이너이신가요?
          </S.Title2>
          <S.Description2>*별도 공지 전까지</S.Description2>
          <S.PriceWrapper align="center" justify="space-between">
            <S.Condition>제휴 코드 입력 시</S.Condition>
            <Flex direction="column" align="flex-end">
              <S.RegularPrice>정가 33,000원/월</S.RegularPrice>
              <Flex gap={8} align="center">
                <S.PriceText>3개월간</S.PriceText>
                <S.Price>0원</S.Price>
              </Flex>
            </Flex>
          </S.PriceWrapper>
          <S.Institutions>
            <S.CenterTitle>제휴 기관/기업 목록</S.CenterTitle>
            {institutions.map(i => (
              <S.Institution key={i}>{i}</S.Institution>
            ))}
          </S.Institutions>
        </Flex>
      </S.Wrapper>
      <FloatButtonContainer>
        <Button onClick={() => setIsOpen(true)}>제휴 코드 입력하기</Button>
      </FloatButtonContainer>
      {isOpen && (
        <Modal onClose={close} style={{ maxWidth: '320px' }}>
          <S.ModalContainer direction="column" gap={20} fullWidth>
            <S.ModalContent>
              기관/기업에서 제공받으신{'\n'}
              제휴 코드를 입력해 주세요
            </S.ModalContent>
            <Flex direction="column">
              <Input
                type="text"
                value={code}
                placeholder="제휴 코드 입력"
                onChange={v => setCode(String(v))}
              />
              {errorMessage && <S.ErrorMessage>{errorMessage}</S.ErrorMessage>}
            </Flex>
            <Flex gap={8} align="center">
              <Button onClick={close} background="anti">
                닫기
              </Button>
              <Button disabled={!code || isLoading} onClick={handleSubmitCode}>
                확인
              </Button>
            </Flex>
          </S.ModalContainer>
        </Modal>
      )}
    </>
  );
}

const institutions = ['WTS', '대한운동학회', '웰링커스', '트라택', '해핏'];

const benefits = [
  '체계적이고 과학적인 회원 관리 기능',
  '무제한 회원 관리 및 알림톡 발송 기능',
  '분야별 전문가 및 상위 1% 인증 기능',
  '전문가 인증 뱃지 통한 브랜딩 기능',
  '33,000원/월'
];

const XIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M20 4.29032L17.7097 2L12 7.72581L6.29032 2L4 4.29032L9.72581 10L4 15.7097L6.29032 18L12 12.2742L17.7097 18L20 15.7097L14.2742 10L20 4.29032Z"
      fill="#8E899F"
    />
  </svg>
);

const TickIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99998 13.3333L5.33331 16L13.3333 24L26.6666 10.6667L24 8L13.3333 18.6667L7.99998 13.3333Z"
      fill="#7750E9"
    />
  </svg>
);
